import { render, staticRenderFns } from "./save-list.vue?vue&type=template&id=431b415a&"
import script from "./save-list.vue?vue&type=script&lang=js&"
export * from "./save-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports